import React from 'react';
import { Card } from './ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { Progress } from './ui/progress';

interface SummaryMetrics {
  scores: {
    product: number;
    market: number;
    financial: number;
    vision: number;
  };
  summary: {
    product: string;
    market: string;
    financial: string;
    vision: string;
  };
}

interface PitchSummaryProps {
  summaryMetrics: SummaryMetrics;
  analysisResults: any;
}

const MetricCard = ({ title, score, description }: { title: string; score: number; description: string }) => (
  <Card className="p-6">
    <h3 className="text-xl font-semibold mb-4">{title}</h3>
    <div className="mb-4">
      <Progress value={score} className="h-2" />
      <span className="text-2xl font-bold mt-2">{score}%</span>
    </div>
    <p className="text-sm text-gray-600">{description}</p>
  </Card>
);

export const PitchSummary: React.FC<PitchSummaryProps> = ({ summaryMetrics, analysisResults }) => {
  const scores = summaryMetrics?.scores || {
    product: 0,
    market: 0,
    financial: 0,
    vision: 0
  };

  const summaries = summaryMetrics?.summary || {
    product: '',
    market: '',
    financial: '',
    vision: ''
  };

  return (
    <div className="space-y-8">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <MetricCard
          title="Product"
          score={scores.product}
          description={summaries.product}
        />
        <MetricCard
          title="Market"
          score={scores.market}
          description={summaries.market}
        />
        <MetricCard
          title="Financial"
          score={scores.financial}
          description={summaries.financial}
        />
        <MetricCard
          title="Vision"
          score={scores.vision}
          description={summaries.vision}
        />
      </div>
    </div>
  );
};
